import { useState } from 'react';

interface Props {
	defaultFilter?: object;
}

export default function useCalendar({ defaultFilter }: Props) {
	const [filter, setFilter] = useState(defaultFilter || {});

	return {
		setFilter,
		filter,
	};
}
